import React from "react";
import { ASSETS } from "../lib/api";

const Registry = () => (
  <div data-testid="registry-page">
    <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-14 lg:pt-20 pb-14 grid lg:grid-cols-12 gap-14 items-center">
      <div className="lg:col-span-6">
        <div className="text-[10px] tracking-[0.4em] uppercase text-gold mb-6">Coming Soon</div>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tighter text-ink">
          Registry
        </h1>
        <p className="mt-6 text-base sm:text-lg text-ink-soft max-w-md leading-relaxed">
          Details will be shared here soon. Please check back a little closer to the date.
        </p>
      </div>
      <div className="lg:col-span-6">
        <img
          src={ASSETS.coupleEmbrace}
          alt="Anjola and Michael"
          loading="lazy"
          className="w-full aspect-[4/5] object-cover max-w-md ml-auto"
        />
      </div>
    </section>

    <section className="max-w-3xl mx-auto px-6 lg:px-10 py-16 text-center">
      <div className="hairline mb-12 justify-center"><span>A · M</span></div>

      <div
        data-testid="registry-coming-soon"
        className="inline-block border border-hairline px-8 py-4 text-[11px] tracking-[0.3em] uppercase text-ink-faint bg-ivory"
      >
        Registry details coming soon
      </div>

      <div className="mt-16">
        <div className="font-serif italic text-2xl text-ink">With love,</div>
        <div className="text-gold text-sm tracking-[0.2em] uppercase mt-1">Anjola &amp; Michael</div>
      </div>
    </section>
  </div>
);

export default Registry;
